import { Component, input, output } from '@angular/core';

import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

import { GroupOption, GroupValue } from '../group-option.interface';

@Component({
  selector: 'app-group-popup',
  templateUrl: './group-popup.component.html',
  styleUrls: ['./group-popup.component.less'],
  standalone: true,
  imports: [NgClickOutsideDelayOutsideDirective],
})
export class GroupPopupComponent {
  readonly options = input<readonly GroupOption[]>([]);
  readonly selectedValue = input<GroupValue>('none');
  readonly select = output<GroupOption>();
  readonly close = output<void>();

  onSelect(option: GroupOption): void {
    this.select.emit(option);
  }

  onClickOutside(): void {
    this.close.emit();
  }
}
